import React from 'react';
import TaxiMeter from './components/TaxiMeter';
import './App.css';

function App() {
  return (
    <div className="App">
      <TaxiMeter />
    </div>
  );
}

export default App;
